module.exports = __webpack_public_path__ + "img/like.6991ad58.svg";